<template>
  <main-content>
    <live-status/>
  </main-content>
</template>

<script type="text/ecmascript-6">
import LiveStatus from "@/pages/live/LiveStatus";


export default {
  methods: {

  },

  components: {
    LiveStatus
  },

  data() {
    return {

        
    };
  },
};
</script>



